import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect, useRef } from 'react';
import Config from '../../../Config';
import PopUp from '../../Shared/Popup/PopUp';
import gaParams from '../../../utilities/analytics/constants';
import { gaEvent } from '../../../utilities/analytics/tracking';
import { clearScreenILAddon } from '../CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import { connect } from 'react-redux';
import { gaExistingAddonsDetails, gaCancelAddonsStep1 } from '../AbroadTicketBlock/gaReports';
import { dwhAbroadAddonExistingPage, dwhRemoveAbroadAddon } from '../CellcomAbroadLobbyBlock/dwhReports';
import PackageDetailsPopup from '../CellcomAbroadLobbyBlock/PackageExists/PopUps/PackageDetailsPopup';
import CancelAddonPackagePopUp from '../CellcomAbroadLobbyBlock/PackageExists/PopUps/CancelAddonPackagePopUp';
import { AbroadSocType } from 'app/Components/Block/CellcomAbroadLobbyBlock/Shared/Models/AbroadPackageModels';
import { removePackage } from '../CellcomAbroadLobbyBlock/Shared/abroadThunk';
const SelfCareAbroadScreenIlAddon = ({ couponData, subscriberMobile, isSubscriberBusiness, removePackage, clearScreenILAddon, cellcomAbroad, userData, abroadAddonList }) => {
  const [popUpDisplay, setPopUpDisplay] = useState('');
  const isMounted = useRef(true);
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  const popUpObject = {
    showInfoPopUp: 'showInfoPopUp',
    showCancelPackagePopUp: 'showCancelPackagePopUp',
    failedCancelPackage: 'FailedCancelPackage',
  };

  const params = {
    channel: isSubscriberBusiness ? 'WebsiteBusiness' : 'WebsitePrivate',
    param1: 'WEBSITE',
    param2: couponData?.socCode,
    param3: cellcomAbroad?.selectedAbroadPackage?.isFamilyBonus
      ? 'בני משפחות'
      : '',
    param4: userData?.contactNumber,
    param5: cellcomAbroad?.selectedCountries.map((c) => c?.countryCode).join(',') ?? '',
    costumerName: userData?.firstName + ' ' + userData?.lastName,
    idNumber: userData?.IDNumber,
    subscriber: subscriberMobile,
  };

  useEffect(() => {
    dwhAbroadAddonExistingPage({ message: 'Existing Addon Displayed', ...params });
  }, []);

  function openInfoPopup() {
    setPopUpDisplay(popUpObject.showInfoPopUp);
    gaExistingAddonsDetails(couponData.packageName);
  }
  function openCancelPopup() {
    dwhAbroadAddonExistingPage({ message: 'Addon Cancel Button Clicked', ...params });
    setPopUpDisplay(popUpObject.showCancelPackagePopUp);
    gaCancelAddonsStep1(couponData.packageName);
  }

  async function cancelPackage() {
    gaEvent(
      gaParams.ABROAD_MY_ABROAD_CLICK_CANCEL_PACKAGE_POP_UP.category,
      gaParams.ABROAD_MY_ABROAD_CLICK_CANCEL_PACKAGE_POP_UP.eventType,
      gaParams.ABROAD_MY_ABROAD_CLICK_CANCEL_PACKAGE_POP_UP.eventParams,
    );

    const removeSocData = {
      soc: couponData.socCode,
      mobile: subscriberMobile,
      startDate: '',
      shouldRemoveSurfingBlockSoc: false,
      isAddon: true,
      noLoader: true
    };

    await removePackage(removeSocData).then((res) => {
      if (res.payload?.Body.isSuccess) {
        dwhRemoveAbroadAddon({ message: 'Success', status: 'Completed', ...params });
      } else {
        dwhRemoveAbroadAddon({ message: 'General Error', status: 'Error', ...params });
      }
    });

    if (isMounted.current) setPopUpDisplay('');
  }
  useEffect(() => {
    if (popUpDisplay) {
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.overflowY = 'auto';
    }
  }, [popUpDisplay]);

  const renderPopUps = () => {
    return (
      <PopUp
        showPopUp={popUpDisplay}
        onClose={() => {
          setPopUpDisplay('');
        }}>
        {popUpDisplay == popUpObject.showCancelPackagePopUp && (
          <CancelAddonPackagePopUp
            cancelPackage={cancelPackage}
            onClose={() => {
              setPopUpDisplay('');
            }}
            dwhParams={params}
            socTitle={couponData.packageName}
          />
        )}
        {popUpDisplay == popUpObject.showInfoPopUp && <PackageDetailsPopup packageData={couponData} />}
      </PopUp>
    );
  };
  return (
    <>
      <div className='package-box'>
        <div className='top-box extra-top-box'>
          <Image className='addon-img' src={Config.epiBaseUrl + couponData.icon} />
          <div className='addon-title-1'> חבילת {couponData.packageName} </div>
          <div className='addon-title-2'>
            למנוי <span style={{ fontWeight: 'bold' }}>{' ' + subscriberMobile + ' '}</span>
            <span> קיימת חבילה {couponData.title}</span>
          </div>
          <div className='addon-title-2'>
            <span style={{ fontWeight: 'bold' }}> קוד קופון {couponData.activationCode}</span>
          </div>
        </div>
        <div className='action-container'>
          <div className={couponData?.permissions?.canCancelPurchuse ? 'more-details-action' : 'more-details-without-cancel-action'} onClick={() => openInfoPopup()}>
            {'פרטים נוספים > '}
          </div>
          {couponData?.permissions?.canCancelPurchuse && (
            <div className='cancel-package-action' onClick={() => openCancelPopup()}>
              {'ביטול חבילה > '}
            </div>
          )}
        </div>
      </div>
      {popUpDisplay && renderPopUps()}
    </>
  );
};

const mapStateToProps = (state) => ({
  cellcomAbroad: state.cellcomAbroad,
  userData: state.authentication?.loginData?.userDetails,
  subscriberMobile: state.selfcarePage?.selectedSubscriber?.productSubscriberNo,
  isSubscriberBusiness: state.selfcarePage?.selectedSubscriber?.isBusinness,
  abroadAddonList: state.selfcarePage?.selectedSubscriber?.abroadAddons,
});
const mapDispatchToProps = {
  removePackage
};

export default connect(mapStateToProps, mapDispatchToProps)(SelfCareAbroadScreenIlAddon);
